export const TUNNELS = ["sdp", "stopover", "hotelonly"] as const;

export type Tunnel = (typeof TUNNELS)[number];

export const isTunnel = (value: string | undefined): value is Tunnel =>
	TUNNELS.includes(value as Tunnel);

/** Maps a tunnel URL path param to its tunnel — the hotel-only deeplink uses `/hotel/ho/...`. */
const TUNNEL_BY_URL_PARAM: Record<string, Tunnel> = {
	sdp: "sdp",
	stopover: "stopover",
	ho: "hotelonly",
};

/** Parses a tunnel URL param into a Tunnel, defaulting to "sdp". */
export const parseTunnelParam = (value: string | undefined): Tunnel =>
	(value && TUNNEL_BY_URL_PARAM[value]) || "sdp";
